<template>
  <v-container class>
    <v-row dense>
      <v-col class="d-flex flex-column flex-sm-row justify-space-between">
        <v-col v-for="(item, i) in items" :key="i" class="col-sm-4">
          <v-card shaped class="mx-0 fill-height">
            <v-img :src="item.imageLink" height="150" class="white--text align-top">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn large color="white" :to="{path: `article/${item.name}`, hash:'start'}" icon>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-actions>
              <v-list-item-content class="ml-5 mt-5">
                <v-list-item-title class="headline" v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
              </v-list-item-content>
            </v-img>

            <v-card-text v-text="item.text"></v-card-text>
          </v-card>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      required: true,
      default: "ru",
    },
  },
  components: {},
  data() {
    return {
      items: this.$store.getters.getBanners,
    };
  },
  methods: {
    clickOnBanner(bannerName) {
      // @click="clickOnBanner(item.name)"
      console.log("bannerName :>> ", bannerName);
      this.$router.push({ path: `article/${bannerName}`, hash: "start" });
    },
    getItems() {
      return [
        this.$vuetify.lang.translator("banner.iosDescription"),
        this.$vuetify.lang.translator("banner.androidDescription"),
        this.$vuetify.lang.translator("banner.serverDescription"),
      ];
    },
  },
  watch: {
    locale() {
      this.$store.commit("updateBanners", this.getItems());
    },
  },
  mounted() {
    this.$store.commit("updateBanners", this.getItems());
  },
};
</script>


<style scoped>
</style>
